import React from "react"
import { Box, Flex, Text, Button, Menu, MenuButton, MenuList, MenuItem, IconButton, Spacer, useDisclosure } from "@chakra-ui/react"
import { NavLink } from "react-router-dom"
import { HamburgerIcon } from "@chakra-ui/icons"

const TopBar = () => {
  const { isOpen, onOpen, onClose } = useDisclosure()

  return (
    <Box bg="teal.500" padding="4" color="white">
      <Flex align="center">
        <Text fontSize="xl" fontWeight="bold">
          My Application
        </Text>
        <Spacer />

        {/* Dropdown Menu for Mobile */}
        <Menu>
          <MenuButton
            as={IconButton}
            aria-label="Options"
            icon={<HamburgerIcon />}
            variant="outline"
            color="white"
            _hover={{ color: "teal.800", bg: "white" }}
            onClick={onOpen}
          />
          <MenuList>
            <MenuItem as={NavLink} to="/" onClick={onClose} color="black">
              Home
            </MenuItem>
            <MenuItem as={NavLink} to="/swap" onClick={onClose} color="black">
              Swap
            </MenuItem>
            <MenuItem as={NavLink} to="/info" onClick={onClose} color="black">
              Info
            </MenuItem>
            <MenuItem as={NavLink} to="/publicKeys" onClick={onClose} color="black">
              Public Keys
            </MenuItem>
          </MenuList>
        </Menu>

        {/* Logout Button */}
        <Button ml={4} colorScheme="teal" variant="outline" onClick={() => alert("Logout")}>
          Logout
        </Button>
      </Flex>
    </Box>
  )
}

export default TopBar
